import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import TemplateList from '../../components/EmailPlatform/TemplateList';

const GET_TEMPLATES_QUERY = gql`
  query GetEmailTemplates {
    emailTemplates {
      id
      name
      subject
      bodyHtml
      title
      subTitle
      headerText
      buttonText
      buttonUrl
      category
      layoutName
      locked
      companyId
      createdById
      version
      deletedAt
      createdAt
      updatedAt
      template_tag_list
    }
    availableMergeFields
    availableEmailLayouts
  }
`;

const TemplateListContainer = (props) => {
  return (
    <Query query={GET_TEMPLATES_QUERY}>
      {({ loading, error, data, refetch }) => {
        if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;
        if (error) return <div style={{ padding: '20px' }}>Error loading templates: {error.message}</div>;

        return (
          <TemplateList
            {...props}
            loading={loading}
            error={error}
            templates={data?.emailTemplates || []}
            mergeFields={data?.availableMergeFields || []}
            emailLayouts={data?.availableEmailLayouts || []}
            refetch={refetch}
          />
        );
      }}
    </Query>
  );
};

TemplateListContainer.propTypes = {
  // Add any props if needed
};

export default TemplateListContainer;
